import { render, staticRenderFns } from "./DAdminSsoMapping.vue?vue&type=template&id=13a5a400&scoped=true&"
import script from "./DAdminSsoMapping.vue?vue&type=script&lang=js&"
export * from "./DAdminSsoMapping.vue?vue&type=script&lang=js&"
import style0 from "./DAdminSsoMapping.vue?vue&type=style&index=0&id=13a5a400&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a5a400",
  null
  
)

export default component.exports